import { CreditCardRewardsType } from "../CreditCardRewardsTypes";


export const CreditCardRewardsTypeFormatted: Record<CreditCardRewardsType, string> = {
  [CreditCardRewardsType.CASH_BACK]: "Cash back",
  [CreditCardRewardsType.CHASE_UR]: "Chase Ultimate Rewards points",
  [CreditCardRewardsType.AMEX_MR]: "American Express Membership Rewards points",
  [CreditCardRewardsType.CITI_TYP]: "Citi ThankYou points",
  [CreditCardRewardsType.CAPITAL_ONE]: "Capital One points",
  [CreditCardRewardsType.BILT_REWARDS]: "Bilt Rewards points",
  [CreditCardRewardsType.WELLS_FARGO]: "Wells Fargo points",
  [CreditCardRewardsType.MARRIOTT_BONVOY]: "Marriott Bonvoy points",
  [CreditCardRewardsType.HILTON]: "Hilton Honors points",
  [CreditCardRewardsType.UNITED]: "United miles",
  [CreditCardRewardsType.ALASKA]: "Alaska Airlines miles",
  [CreditCardRewardsType.AMERICAN]: "American Airlines miles",
  [CreditCardRewardsType.AVIOS]: "Avios",
  [CreditCardRewardsType.SOUTHWEST]: "Southwest miles",
  [CreditCardRewardsType.JETBLUE]: "JetBlue points",
  [CreditCardRewardsType.HAWAIIAN]: "Hawaiian miles",
  [CreditCardRewardsType.FRONTIER]: "Frontier miles",
  // [CreditCardRewardsType.BEST_WESTERN]: "Best Western points",
  [CreditCardRewardsType.CHOICE]: "Choice Privileges points",
  [CreditCardRewardsType.HYATT]: "World of Hyatt points",
  [CreditCardRewardsType.IHG]: "IHG points",
  [CreditCardRewardsType.WYNDHAM]: "Wyndham points",
  [CreditCardRewardsType.DISNEY_REWARDS_DOLLARS]: "Disney Rewards dollars",
  [CreditCardRewardsType.AIRLINE]: "Airline miles",
  [CreditCardRewardsType.NORWEGIAN_CRUISE_POINTS]: "Norwegian Cruise points",
  [CreditCardRewardsType.BREEZEPOINTS]: "Breeze points",
  [CreditCardRewardsType.TRAVEL]: "Travel points",
  [CreditCardRewardsType.MILES]: "Miles",
  [CreditCardRewardsType.MYCRUISE_POINTS]: "MyCruise points",
  [CreditCardRewardsType.POINTS]: "Points",

  [CreditCardRewardsType.UNKNOWN]: "Unknown",
};

export const formatRewardsType = (value: CreditCardRewardsType) => {
  return CreditCardRewardsTypeFormatted[value] ?? value;
}





